import $ from 'jquery';
// import mpro from './mpro.init';

// Execute various tracking handlers on page change
mpro.callTracking = function() {

	// Inform Google Analytics of the change
	if (typeof window.ga !== 'undefined') {
		window.ga('set', 'page', location.pathname + location.search + location.hash);
		window.ga('send', 'pageview');
	}
	// Inform Google Analytics of the change (old api)
	else if (typeof window._gaq !== 'undefined') {
		window._gaq.push(['_trackPageview', location.href]);
	}

	// Inform Facebook Pixel Code of the change
	if (typeof window.fbq !== 'undefined') {
		window.fbq('send', 'PageView', location.href);
	}

	// GTM tracking
	if (window.dataLayer && window.dataLayer.push) {
		window.dataLayer.push({
			'event': 'Pageview',
			'pagePath': location.pathname + location.search + location.hash,
			'pageTitle': document.title,
		});
	}
};

// GTM click handler
mpro.gtmHandleClick = function($container) {
	$container.find(window.gtmClickSelector).on('click.gtm-click', function(e) {
		window.pushGtmClick && window.pushGtmClick(e.delegateTarget, e.originalEvent);
		const $this = $(this);
		const tracking = $this.data('tracking');
		window.fbq && window.fbq('track', 'Purchase', { content_name: tracking.name, content_ids: [tracking.id], content_type: 'product', value: tracking.price, currency: tracking.currency });
	});
};

export default mpro;
